import React, { createContext } from 'react';
import usePlatformAgent from '../hooks/platform-agent/usePlatformAgent';

// What everything outside the provider sees: no Amigo.
export const NO_PLATFORM_AGENT = Object.freeze({
  available: false,
  unavailable: false,
  launcher: false,
  context: null,
  subjectKey: null,
  name: null,
  requestHeaders: null,
  chatsManager: null,
  filesManager: null,
  checkHealth: null,
});

export const PlatformAgentContext = createContext(NO_PLATFORM_AGENT);

/**
 * The platform agent's state for the dashboard shell (usePlatformAgent), loaded once for every consumer: the
 * button, the panel, the Intercom companion and the checklist that moves out of their way. Each usePlatformAgent
 * call builds its own API clients, so nothing else calls it.
 */
export default function PlatformAgentProvider({ children }) {
  const state = usePlatformAgent();

  return <PlatformAgentContext.Provider value={state}>{children}</PlatformAgentContext.Provider>;
}
